var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsOpenInNewWindowOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.9,51.8l19.3-19.4v10.7c0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2V24.8H58.4c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2h10.6 L49.8,48.6L52.9,51.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34,13.5c-3.3,0-6,2.7-6,6v6h-6c-3.3,0-6,2.7-6,6v48c0,3.3,2.7,6,6,6h48c3.3,0,6-2.7,6-6v-6h6c3.3,0,6-2.7,6-6v-54H34z  M71.5,79.5c0,0.8-0.7,1.5-1.5,1.5H22c-0.8,0-1.5-0.7-1.5-1.5v-48c0-0.8,0.7-1.5,1.5-1.5h6v37.5c0,3.3,2.7,6,6,6h37.5V79.5z  M83.5,67.5c0,0.8-0.7,1.5-1.5,1.5h-6h-4.5H34c-0.8,0-1.5-0.7-1.5-1.5V30v-4.5v-6c0-0.8,0.7-1.5,1.5-1.5h49.5V67.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsOpenInNewWindowOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_OpenInNewWindow_Outline_Brand.f31870f65f730ad751837926ea25d2d0.svg";
export { ForwardRef as ReactComponent };